// Add your custom JS here.
(function () {
	function initGalleryThumbNavigationInSlide(slideElement) {
		if (!slideElement) {
			return;
		}

		slideElement.querySelectorAll('.jamesbs-modal-product-gallery').forEach(function (galleryElement) {
			if (galleryElement.getAttribute('data-gallery-initialized') === '1') {
				return;
			}

			var mainImages = galleryElement.querySelectorAll('.jamesbs-modal-product-gallery-main-image');
			var thumbs = galleryElement.querySelectorAll('.jamesbs-modal-product-gallery-thumb');

			if (!mainImages.length || !thumbs.length) {
				galleryElement.setAttribute('data-gallery-initialized', '1');
				return;
			}

			var setActiveImage = function (index) {
				mainImages.forEach(function (mainImage) {
					mainImage.classList.add('d-none');
				});

				thumbs.forEach(function (thumbButton) {
					thumbButton.classList.remove('active');
					thumbButton.setAttribute('aria-current', 'false');
				});

				if (mainImages[index]) {
					mainImages[index].classList.remove('d-none');
				}

				if (thumbs[index]) {
					thumbs[index].classList.add('active');
					thumbs[index].setAttribute('aria-current', 'true');
				}
			};

			thumbs.forEach(function (thumbButton) {
				thumbButton.addEventListener('click', function () {
					var parsedIndex = parseInt(thumbButton.getAttribute('data-image-index') || '0', 10);
					setActiveImage(Number.isNaN(parsedIndex) ? 0 : parsedIndex);
				});
			});

			setActiveImage(0);
			galleryElement.setAttribute('data-gallery-initialized', '1');
		});
	}

	function initProductGalleryModal(modalElement) {
		if (!modalElement) {
			return;
		}

		var carouselElement = modalElement.querySelector('.js-product-gallery-carousel');
		if (!carouselElement) {
			return;
		}

		var hasBootstrap5 = typeof bootstrap !== 'undefined' && bootstrap.Carousel;
		var hasJqueryCarousel = typeof jQuery !== 'undefined' && typeof jQuery.fn.carousel === 'function';
		var carousel = hasBootstrap5
			? bootstrap.Carousel.getOrCreateInstance(carouselElement, {
					interval: false,
					wrap: true,
					touch: true,
				})
			: null;

		if (hasJqueryCarousel) {
			jQuery(carouselElement).carousel({
				interval: false,
				wrap: true,
				touch: true,
			});
		}

		if (!hasBootstrap5 && hasJqueryCarousel) {
			var touchStartX = 0;
			var touchStartY = 0;
			var swipeThreshold = 40;

			carouselElement.addEventListener(
				'touchstart',
				function (event) {
					if (!event.touches || event.touches.length !== 1) {
						return;
					}

					touchStartX = event.touches[0].clientX;
					touchStartY = event.touches[0].clientY;
				},
				{ passive: true }
			);

			carouselElement.addEventListener('touchend', function (event) {
				if (!event.changedTouches || !event.changedTouches.length) {
					return;
				}

				var deltaX = event.changedTouches[0].clientX - touchStartX;
				var deltaY = event.changedTouches[0].clientY - touchStartY;

				if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
					return;
				}

				if (deltaX < 0) {
					jQuery(carouselElement).carousel('next');
				} else {
					jQuery(carouselElement).carousel('prev');
				}
			});
		}

		var pendingSlideIndex = 0;

		var setActiveSlide = function (index) {
			var slides = carouselElement.querySelectorAll('.carousel-item');
			if (!slides.length) {
				return 0;
			}

			var safeIndex = ((index % slides.length) + slides.length) % slides.length;
			slides.forEach(function (slide, slideIndex) {
				slide.classList.remove('active', 'carousel-item-start', 'carousel-item-end');
				if (slideIndex === safeIndex) {
					slide.classList.add('active');
				}
			});

			return safeIndex;
		};

		var goToSlide = function (index) {
			pendingSlideIndex = setActiveSlide(index);

			if (carousel) {
				carousel.to(pendingSlideIndex);
			} else if (hasJqueryCarousel) {
				jQuery(carouselElement).carousel(pendingSlideIndex);
			}
		};

		var handleShow = function (event) {
			var slideIndex = 0;
			if (event.relatedTarget) {
				var parsedIndex = parseInt(event.relatedTarget.getAttribute('data-gallery-slide') || '0', 10);
				slideIndex = Number.isNaN(parsedIndex) ? 0 : parsedIndex;
			}

			goToSlide(slideIndex);
		};

		var handleShown = function () {
			goToSlide(pendingSlideIndex);
			initGalleryThumbNavigationInSlide(carouselElement.querySelector('.carousel-item.active'));
		};

		var handleSlid = function () {
			initGalleryThumbNavigationInSlide(carouselElement.querySelector('.carousel-item.active'));
		};

		if (hasJqueryCarousel) {
			jQuery(modalElement).on('show.bs.modal', handleShow);
			jQuery(modalElement).on('shown.bs.modal', handleShown);
			jQuery(carouselElement).on('slid.bs.carousel', handleSlid);
		} else {
			modalElement.addEventListener('show.bs.modal', handleShow);
			modalElement.addEventListener('shown.bs.modal', handleShown);
			carouselElement.addEventListener('slid.bs.carousel', handleSlid);
		}
	}

	function initSliderBlockCarousel(carouselElement) {
		if (!carouselElement || carouselElement.getAttribute('data-slider-carousel-initialized') === '1') {
			return;
		}

		var hasBootstrap5 = typeof bootstrap !== 'undefined' && bootstrap.Carousel;
		var hasJqueryCarousel = typeof jQuery !== 'undefined' && typeof jQuery.fn.carousel === 'function';

		if (hasBootstrap5) {
			bootstrap.Carousel.getOrCreateInstance(carouselElement, {
				interval: 3000,
				wrap: true,
				touch: true,
				pause: false,
			});
		}

		if (hasJqueryCarousel) {
			jQuery(carouselElement).carousel({
				interval: 3000,
				wrap: true,
				touch: true,
				pause: false,
			});
		}

		if (!hasBootstrap5 && hasJqueryCarousel) {
			var touchStartX = 0;
			var touchStartY = 0;
			var swipeThreshold = 40;

			carouselElement.addEventListener(
				'touchstart',
				function (event) {
					if (!event.touches || event.touches.length !== 1) {
						return;
					}

					touchStartX = event.touches[0].clientX;
					touchStartY = event.touches[0].clientY;
				},
				{ passive: true }
			);

			carouselElement.addEventListener('touchend', function (event) {
				if (!event.changedTouches || !event.changedTouches.length) {
					return;
				}

				var deltaX = event.changedTouches[0].clientX - touchStartX;
				var deltaY = event.changedTouches[0].clientY - touchStartY;

				if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
					return;
				}

				if (deltaX < 0) {
					jQuery(carouselElement).carousel('next');
				} else {
					jQuery(carouselElement).carousel('prev');
				}
			});
		}

		carouselElement.setAttribute('data-slider-carousel-initialized', '1');
	}

	// Keep the WP Menu Cart menu item in sync after AJAX cart changes.
	// WooCommerce only refreshes cart fragments on cart/checkout pages since
	// WC 7.8, and the plugin's click-timer fallback can read a stale cart on
	// slow responses, so refresh on the events WC fires once the cart has
	// actually changed. Uses the plugin's documented `wpmenucart_update_cart_ajax`
	// handle plus its localized ajax/nonce data (always enqueued via
	// wpmenucart-remove).
	if (window.jQuery) {
		window.jQuery(function ($) {
			if (typeof window.wpmenucart_ajax === 'undefined') {
				return;
			}

			var refreshTimer;

			var refreshMenuCart = function () {
				window.clearTimeout(refreshTimer);
				refreshTimer = window.setTimeout(function () {
					$.post(
						window.wpmenucart_ajax.ajaxurl,
						{
							security: window.wpmenucart_ajax.nonce,
							action: window.wpmenucart_ajax.action,
						}
					).done(function (response) {
						if (!response || !response.data) {
							return;
						}

						if (response.data.menu_cart) {
							$('.wpmenucartli').html(response.data.menu_cart);
						}

						if ($('.wpmenucart-slideout').length && response.data.mini_cart_slideout) {
							$('.wpmenucart-slideout').replaceWith(response.data.mini_cart_slideout);
						}
					});
				}, 250);
			};

			$(document.body).on(
				'added_to_cart removed_from_cart updated_wc_div wc_fragments_refreshed',
				refreshMenuCart
			);
			$(document).on('wpmenucart_update_cart_ajax', refreshMenuCart);
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.js-product-gallery-modal').forEach(function (modalElement) {
			initProductGalleryModal(modalElement);
		});

		// Initialise thumbnail navigation for galleries rendered outside the
		// modal (single product pages). The data-gallery-initialized guard
		// prevents the modal galleries from being bound twice.
		initGalleryThumbNavigationInSlide(document);

		document.querySelectorAll('section.slider .carousel').forEach(function (carouselElement) {
			initSliderBlockCarousel(carouselElement);
		});

		var backToTop = document.getElementById('back-to-top');
		if (backToTop) {
			var toggleBackToTop = function () {
				backToTop.classList.toggle('is-visible', window.scrollY > 300);
			};

			toggleBackToTop();
			window.addEventListener('scroll', toggleBackToTop, { passive: true });

			backToTop.addEventListener('click', function () {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			});
		}
	});
})();